const fonts = {
  CabinRegular: "font-family: 'Cabin Regular', Arial, sans-serif;",
  CabinBold: "font-family: 'Cabin Bold', Arial, sans-serif;",
  RalewayThin: "font-family: 'Raleway Thin', Arial, sans-serif;",
  RalewayRegular: "font-family: 'Raleway Regular', Arial, sans-serif;",
  RalewayMedium: "font-family: 'Raleway Medium', Arial, sans-serif;",
  Lagi: "font-family: 'Lagi Regular', Arial, sans-serif;"
};

export default fonts;